import React from 'react';
import Delivery from './Delivery';
const DeliveryS = ({ color, ...props }) => (React.createElement(Delivery, Object.assign({ color: color, size: 24 }, props)));
DeliveryS.displayName = 'DeliveryS'; // Fix for tsc
export default DeliveryS;
//# sourceMappingURL=DeliveryS.js.map